import ThemeSwitcher from '../components/theme-switcher.js';
import AlgoliaSearch from '../components/algolia-search.js';
import FuzzySearch from '../components/fuzzy-search.js';

import searchFormTemplate from '../../templates/search-form.js';
import allResults from '../components/all-results.js';
import loginButtonTemplate from '../../templates/login-button.js';
import themeSwitcherTemplate from '../../templates/theme-switcher.js';
import footerTemplate from '../../templates/footer.js';

export default class LayoutBuilder {
  constructor() {
    this.header = $('.navbar-header');
    this.siteBody = $('.site-body-row');
    this.search = $('.site-sidebar-search');
    this.document = $(document);
  }

  build() {
    this._injectTemplates();
    this._initializePermanentContent();
    this._listenOnPermanentEvents();
  }

  _injectTemplates() {
    //inject search to header
    this.header.append(searchFormTemplate);
    this.header.append(allResults);
    // reinitialize Paligo search engine
    this.document.trigger('search.ready');

    // inject login button to header
    this.header.append(loginButtonTemplate);

    // inject theme switcher button to header
    this.header.append(themeSwitcherTemplate);

    //inject footer
    this.siteBody.append(footerTemplate);
  }

  _initializePermanentContent() {
    this.themeSwitcher = new ThemeSwitcher();
    this.search =
      typeof algoliasearch === 'function'
        ? new AlgoliaSearch()
        : new FuzzySearch();

    // rename home navigation item in the left menu
    $(`.site-sidebar .nav-site-sidebar > li > a:contains('Home')`).text(
      'Docs Home'
    );
  }

  _listenOnPermanentEvents() {
    this.themeSwitcher.listenEvents();
    this.search.listenEvents();
  }
}
